


















import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import LoadingIndicator from "@/view/shared-components/LoadingIndicator.vue";

@Component({
    components: {LoadingIndicator}
})
export default class SubmitTicketButtonGroupDesktop extends Vue {
    @Prop({required: false}) allowSubmit!:boolean;
    @Prop({required: false}) allowReset!:boolean;
    @Prop({required: false}) submitButtonText!:string;
    @Prop({required: false}) lgCol!:number;

    @Prop({required: false}) submitButtonBusy!:boolean;

    @Prop({required: false}) utilityButtonText!: string;
    @Prop({required: false}) utilityButtonIcon!: string;
    @Prop({required: false}) utilityButtonVariant!: string;
    @Prop({required: false}) utilityButtonBusy!: boolean;

    private submitVariant: string = 'outline-secondary';
    private resetVariant: string = 'outline-secondary';


    @Watch('allowReset', {immediate:true})
    onResetChange(value: boolean, oldValue:boolean){
        if (value) {
            this.resetVariant = 'warning'
        } else {
            this.resetVariant = 'outline-secondary'
        }
    }
    @Watch('allowSubmit', {immediate:true})
    onSubmitChange(value: boolean, oldValue:boolean){
        if (value) {
            this.submitVariant = 'secondary'
        } else {
            this.submitVariant = 'outline-secondary'
        }
    }

    utilityButtonFunction(){
        this.$emit('utilityButtonFunction')
    }
}
